import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  buttonsStyle,
  dateFormatter,
  substringFormatter,
} from "../../../components/tables/table";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { deleteLeat, getLeats, updateLeat, markLeatsAsRead } from "../../../../api/leat";
import {
  Button,
  makeStyles,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import { shallowEqual, useSelector } from "react-redux";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getRelojes } from "../../../../api/reloj";
import { SERVER_URL } from "../../../../api";

function buildWhatsAppUrl(phone, text) {
  if (!phone) return null;
  const digits = String(phone).replace(/\D/g, "");
  const num = digits.startsWith("34") ? digits : digits.length <= 9 ? "34" + digits : digits;
  const base = `https://wa.me/${num}`;
  if (text) return `${base}?text=${encodeURIComponent(text)}`;
  return base;
}

function WhatsAppIcon({ style = {} }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#25D366" style={{ verticalAlign: "middle", ...style }} aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

function getData(leats, relojes) {
  let data = [];

  for (let i = 0; i < leats.length; ++i) {
    const elem = {};
    elem.nombre = leats[i]?.nombre;
    elem.email = leats[i]?.email || "";
    elem.telefono = leats[i]?.telefono || "";
    elem.reloj = (leats[i]?.reloj && typeof leats[i].reloj === "object" && leats[i].reloj?.name)
      ? leats[i].reloj.name
      : relojes.find((x) => String(x._id) === String(leats[i]?.reloj))?.name ?? "";
    elem.message = leats[i]?.message;
    elem.createdAt = leats[i]?.createdAt;
    elem.id = leats[i]?._id;
    elem.images = leats[i]?.images || [];
    elem.tipo = leats[i]?.tipo || "solicitud";
    elem.modeloId = leats[i]?.modeloId;
    elem.estado = leats[i]?.estado;
    elem.contenido = leats[i]?.contenido;
    elem._id = leats[i]?._id;
    elem.read = leats[i]?.read === true;
    data = data.concat(elem);
  }
  return data;
}

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function LeatsPage() {
  const [data, setData] = useState([]);
  const [relojes, setRelojes] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [leat, setLeat] = useState({});
  const [leatId, setLeatId] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsItem, setDetailsItem] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [userFilter, setUserFilter] = useState("Todos");
  const [markingAllRead, setMarkingAllRead] = useState(false);
  const history = useHistory();
  const classes = useStyles();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const columns = [
    { dataField: "nombre", text: "Nombre", sort: true },
    { dataField: "email", text: "Email", sort: true },
    { dataField: "telefono", text: "Teléfono", sort: true },
    {
      dataField: "message",
      text: "Mensaje",
      sort: true,
      formatter: substringFormatter,
    },
    { dataField: "reloj", text: "Reloj", sort: true },
    { dataField: "createdAt", text: "Fecha", formatter: dateFormatter },
    { dataField: "id", text: "", formatter: buttonFormatter, style: { width: 260 }, headerStyle: { width: 260 } },
  ];

  function buttonFormatter(cell) {
    // Usar los datos ya transformados para evitar campos no serializables
    const transformed = getData(filteredData, relojes);
    const elem = transformed.find((item) => item.id === cell);
    return (
      <>
        {user?.role === "admin" && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "nowrap" }}>
              <span style={{ width: 40, minWidth: 40, display: "inline-flex", justifyContent: "center", flexShrink: 0 }}>
                {elem.telefono ? (
                  <Tooltip title="Abrir WhatsApp">
                    <Button
                      size="small"
                      component="a"
                      href={buildWhatsAppUrl(elem.telefono)}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ minWidth: 40, padding: 6 }}
                    >
                      <WhatsAppIcon />
                    </Button>
                  </Tooltip>
                ) : null}
              </span>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                startIcon={<VisibilityIcon />}
                onClick={async () => {
                // Obtener el leat completo con todos los campos (incluyendo images)
                const fullLeat = data.find((item) => item._id === elem._id || item.id === elem.id);
                setDetailsItem(fullLeat || elem);
                setDetailsOpen(true);
                // Marcar como leído cuando se visualiza
                if (elem?.id || elem?._id) {
                  try {
                    await updateLeat(elem.id || elem._id, { read: true });
                    // Actualizar el estado local
                    setFilteredData((prev) =>
                      prev.map((item) =>
                        (item._id === elem._id || item.id === elem.id) ? { ...item, read: true } : item
                      )
                    );
                    setData((prev) =>
                      prev.map((item) =>
                        (item._id === elem._id || item.id === elem.id) ? { ...item, read: true } : item
                      )
                    );
                    window.dispatchEvent(new Event("refreshUnreadCounts"));
                  } catch (error) {
                    console.error("Error marking leat as read:", error);
                  }
                }
              }}
                style={{
                  textTransform: "none",
                  minWidth: "120px",
                  flexShrink: 0,
                }}
              >
                Ver Detalles
              </Button>
              <Tooltip title="Delete">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    setLeat(elem);
                    setOpenConfirmDialog(2);
                  }}
                >
                  <DeleteIcon />
                </Button>
              </Tooltip>
            </div>
        )}
      </>
    );
  }

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const resRelojes = await getRelojes({ propio: true });
        const resLeats = await getLeats();
        if (resRelojes.status === 200 && resLeats.status === 200) {
          setData(resLeats.data);
          setFilteredData(resLeats.data);
          setRelojes(resRelojes.data);
          setLoading(false);
          setRefresh(false);
        }
      } catch (error) {
        alertError({ error: error, customMessage: "Could not get leats." });
      }
    };
    fetchData();
  }, [refresh]);

  useEffect(() => {
    // Filtrar por usuario (nombre/email)
    if (userFilter === "Todos") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((leat) => {
        const nombre = leat.nombre || "";
        const email = leat.email || "";
        // Comparar con el formato exacto del select
        const displayName = nombre || email ? `${nombre}${email ? ` (${email})` : ""}` : "";
        return displayName === userFilter;
      });
      setFilteredData(filtered);
    }
  }, [userFilter, data]);

  useEffect(() => {
    return () => {
      markLeatsAsRead().catch(() => {});
    };
  }, []);

  return (
    <>
      <Card>
        <CardHeader title="Lista Leats">
          <CardHeaderToolbar>
            <Button
              type="button"
              className="btn btn-light-primary btn-sm mr-2"
              onClick={async () => {
                try {
                  setMarkingAllRead(true);
                  await markLeatsAsRead();
                  setData((prev) => prev.map((it) => ({ ...it, read: true })));
                  setFilteredData((prev) => prev.map((it) => ({ ...it, read: true })));
                  window.dispatchEvent(new Event("refreshUnreadCounts"));
                  alertSuccess({ customMessage: "Todos los mensajes marcados como leídos." });
                } catch (err) {
                  alertError({ error: err, customMessage: "Error al marcar como leídos." });
                } finally {
                  setMarkingAllRead(false);
                }
              }}
              disabled={markingAllRead}
              startIcon={<DoneAllIcon />}
            >
              {markingAllRead ? "Marcando…" : "Marcar todos como leídos"}
            </Button>
            {selectedRows.length > 0 && (
              <Button
                type="button"
                className="btn btn-danger"
                onClick={() => setOpenConfirmDialog(3)}
                startIcon={<DeleteIcon />}
              >
                Borrar seleccionados ({selectedRows.length})
              </Button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="form-group mb-4">
            <label>Filtrar por nombre/email</label>
            <select
              className="form-control"
              value={userFilter}
              onChange={(e) => setUserFilter(e.target.value)}
              style={{ maxWidth: "300px" }}
            >
              <option value="Todos">Todos</option>
              {Array.from(
                new Set(
                  data
                    .map((leat) => {
                      const nombre = leat.nombre || "";
                      const email = leat.email || "";
                      return nombre || email ? `${nombre}${email ? ` (${email})` : ""}` : null;
                    })
                    .filter(Boolean)
                    .sort()
                )
              ).map((user) => (
                <option key={user} value={user}>
                  {user}
                </option>
              ))}
            </select>
          </div>
          <Table 
            data={getData(filteredData, relojes)} 
            columns={columns}
            onSelectionChange={setSelectedRows}
            selected={selectedRows}
            rowClasses={(row) => (row.read === false ? "unread-row" : "")}
          />
          <Dialog
            open={detailsOpen}
            onClose={() => setDetailsOpen(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Detalles del mensaje</DialogTitle>
            <DialogContent dividers className={classes.dialogContent}>
              <div style={{ padding: 16 }}>
                <p>
                  <strong>Nombre:</strong> {detailsItem?.nombre || "-"}
                </p>
                <p>
                  <strong>Email:</strong> {detailsItem?.email || "-"}
                </p>
                <p>
                  <strong>Teléfono:</strong> {detailsItem?.telefono || "-"}
                </p>
                <p>
                  <strong>Reloj:</strong> {detailsItem?.reloj && typeof detailsItem.reloj === "object" ? detailsItem.reloj.name : (detailsItem?.reloj || "-")}
                </p>
                <p>
                  <strong>Fecha:</strong>{" "}
                  {detailsItem?.createdAt
                    ? new Date(detailsItem.createdAt).toLocaleString("es-ES")
                    : "-"}
                </p>
                <div style={{ marginTop: 16 }}>
                  <p>
                    <strong>Mensaje:</strong>
                  </p>
                  <div
                    style={{
                      backgroundColor: "#f5f5f5",
                      borderRadius: 4,
                      padding: 12,
                      whiteSpace: "pre-line",
                    }}
                  >
                    {detailsItem?.message ? (
                      detailsItem.message.split('\n').map((line, index) => {
                        // Detectar URLs y hacerlas clickeables
                        const urlRegex = /(https?:\/\/[^\s]+)/g;
                        const parts = line.split(urlRegex);
                        return (
                          <div key={index} style={{ marginBottom: index < detailsItem.message.split('\n').length - 1 ? 4 : 0 }}>
                            {parts.map((part, partIndex) => {
                              if (urlRegex.test(part)) {
                                return (
                                  <a
                                    key={partIndex}
                                    href={part}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#1976d2",
                                      textDecoration: "underline",
                                      wordBreak: "break-all",
                                    }}
                                  >
                                    {part}
                                  </a>
                                );
                              }
                              return <span key={partIndex}>{part}</span>;
                            })}
                          </div>
                        );
                      })
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                
                {/* Mostrar imágenes si existen */}
                {detailsItem?.images && detailsItem.images.length > 0 && (
                  <div style={{ marginTop: 24 }}>
                    <p>
                      <strong>Imágenes adjuntas ({detailsItem.images.length}):</strong>
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "12px",
                        marginTop: "12px",
                      }}
                    >
                      {detailsItem.images.map((imagePath, index) => {
                        // Si la imagen es base64 (data:image), usarla directamente
                        // Si es una URL, usarla directamente
                        // Si es una ruta local, construir la URL completa
                        let imageUrl = imagePath;
                        if (imagePath && !imagePath.startsWith("data:image") && !imagePath.startsWith("http")) {
                          // Normalizar la ruta: reemplazar backslashes por forward slashes (Windows usa \)
                          const normalizedPath = imagePath.replace(/\\/g, '/');
                          // Construir la URL completa de la imagen
                          imageUrl = `${SERVER_URL}${normalizedPath.startsWith("/") ? normalizedPath : `/${normalizedPath}`}`;
                        }
                        
                        return (
                          <div
                            key={index}
                            style={{
                              position: "relative",
                              width: "200px",
                              height: "200px",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              overflow: "hidden",
                              cursor: "pointer",
                            }}
                            onClick={() => window.open(imageUrl, "_blank")}
                          >
                            <img
                              src={imageUrl}
                              alt={`Imagen ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                              onError={(e) => {
                                e.target.src = "https://via.placeholder.com/200x200?text=Error+loading+image";
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                right: 0,
                                backgroundColor: "rgba(0, 0, 0, 0.6)",
                                color: "#fff",
                                padding: "4px 8px",
                                fontSize: "12px",
                                textAlign: "center",
                              }}
                            >
                              Click para ampliar
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                
                {/* Mostrar información adicional para tasaciones */}
                {detailsItem?.tipo === "tasacion" && (
                  <div style={{ marginTop: 24 }}>
                    <p>
                      <strong>Tipo:</strong> Solicitud de tasación
                    </p>
                    {detailsItem?.estado && (
                      <p>
                        <strong>Estado del reloj:</strong> {detailsItem.estado}
                      </p>
                    )}
                    {detailsItem?.contenido && (
                      <p>
                        <strong>Contenido:</strong>{" "}
                        {detailsItem.contenido.estuche && detailsItem.contenido.documento
                          ? "Con estuche y documentos"
                          : detailsItem.contenido.estuche
                          ? "Con estuche"
                          : detailsItem.contenido.documento
                          ? "Con documentos"
                          : "Solo reloj"}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setDetailsOpen(false)}
                color="primary"
                autoFocus
              >
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
          <ConfirmDialog
            title={"Are you sure you want to remove this brand?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteLeat(leat?._id)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Brand removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove brand.",
                  });
                });
            }}
          />
          <ConfirmDialog
            title={`¿Estás seguro de que quieres borrar ${selectedRows.length} elemento(s)?`}
            open={openConfirmDialog === 3}
            setOpen={setOpenConfirmDialog}
            onConfirm={async () => {
              try {
                // Borrar todos los elementos seleccionados
                const deletePromises = selectedRows.map((row) =>
                  deleteLeat(row.id)
                );
                await Promise.all(deletePromises);
                
                alertSuccess({
                  title: "Eliminados!",
                  customMessage: `${selectedRows.length} elemento(s) eliminado(s) correctamente.`,
                });
                setSelectedRows([]);
                setRefresh(true);
              } catch (error) {
                alertError({
                  error: error,
                  customMessage: "Error al eliminar los elementos seleccionados.",
                });
              }
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
